module.exports = __webpack_public_path__ + "static/media/expandir-mas.91ea69eb.svg";